// extracted by mini-css-extract-plugin
export default {"innerWrapper":"XB-z","tooltipWrapper":"YB-z","icon":"ZB-z","tooltip":"_B-z","content":"aC-z"};